export default {
  login: 'loginAction',
  getProperties: 'getProperties',
  tfaLogin: 'tfaLogin',
}
